import styled from "styled-components";

export const Container = styled.div`
  background: linear-gradient(
    90deg,
    ${(props) => props.theme["blue-700"]} 0%,
    ${(props) => props.theme["blue-400"]} 100%
  );
  color: ${(props) => props.theme.white};
  display: flex;
  justify-content: center;
  padding: 0.25rem 1.25rem;

  width: 100%;
  z-index: 99999;
  text-align: center;

  h4 {
    color: ${(props) => props.theme.white};
    font-size: 0.875rem;
    margin: 0px;
  }

  a {
    text-align: center;
    text-decoration: none;
    font-size: 0.875rem;
    margin: 0px;
    color: ${(props) => props.theme.white};

    &:hover {
      text-decoration: underline;
    }
  }
`;
